<template>
  <component :is="itemData === undefined ? 'div' : 'b-card'">
    <b-alert
      variant="danger"
      :show="itemData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'app-admin-banners'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <form-edit-add
      :value="itemData"
      class="pt-75"
      @handleSubmit="handleSubmit"
      @removeImagem="removeImagem"
    />

  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosAWS from '@axiosAWS'
import FormEditAdd from './FormEditAdd.vue'
import FormImagens from './FormImagens.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    FormImagens,
    FormEditAdd,
  },
  setup() {
    const toast = useToast()
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    const itemData = ref({
      id: null,
      nome: '',
      imagem: '',
      imagem_key: '',
      imagem_mobile: '',
      imagem_mobile_key: '',
      ativo: 1,
      nome_tag: '',
      link: '',
    })

    const resetClienteData = () => {
      itemData.value = {
        id: null,
        nome: '',
        imagem: '',
        imagem_key: null,
        imagem_mobile: '',
        imagem_mobile_key: null,
        ativo: 1,
        nome_tag: '',
        link: '',
      }
    }
    const isBase64Image = image => image.startsWith('data:image/')

    const imageUrl = ref({
      imagem: '',
      imagem_key: '',
      imagem_mobile: '',
      imagem_mobile_key: '',
    })

    const convertBase64ToFile = (base64Image, fileName) => {
      const mimeType = base64Image.split(';')[0].split(':')[1]
      const byteString = atob(base64Image.split(',')[1])
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const uint8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }

      const blob = new Blob([arrayBuffer], { type: mimeType })
      return new File([blob], fileName, { type: mimeType })
    }

    const removeImagem = async () => {
      if (itemData.value.imagem_key !== null) {
        await axiosAWS
          .delete('/delete', {
            data: {
              file_key: itemData.value.imagem_key,
            },
          })
          .then(() => {
            itemData.value.imagem = null
            itemData.value.imagem_key = null
            imageUrl.value.imagem = null
            imageUrl.value.imagem_key = null
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: 'Erro ao remover imagem',
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          })
      }
    }

    const uploadImagem = async () => {
      let imageFile = null

      if (isBase64Image(itemData.value.imagem)) {
        const randoNumber = Math.random().toString(36).substring(2, 15)
        imageFile = convertBase64ToFile(itemData.value.imagem, `banner_${itemData.value.nome}_${randoNumber}`)
        const formData = new FormData()
        formData.append('image', imageFile)
        formData.append(
          'caminho',
          `${userData.value.uuid}_${userData.value.id}/banners_imagens/banner_${userData.value.uuid}_${itemData.value.nome.replace(
            /[^\w]/g,
            '_',
          )}`,
        )

        await axiosAWS
          .post('/upload', formData)
          .then(async response => {
            imageUrl.value.imagem = response.data.image_url
            imageUrl.value.imagem_key = response.data.key
          })
      }
      // Upload banner mobile
      if (isBase64Image(itemData.value.imagem_mobile)) {
        const randoNumber = Math.random().toString(36).substring(2, 15)
        const imageFileMobile = convertBase64ToFile(itemData.value.imagem_mobile, `banner_mobile_${itemData.value.nome}_${randoNumber}`)
        const formDataMobile = new FormData()
        formDataMobile.append('image', imageFileMobile)
        formDataMobile.append(
          'caminho',
          `${userData.value.uuid}_${userData.value.id}/banners_imagens/banner_mobile_${userData.value.uuid}_${itemData.value.nome.replace(
            /[^\w]/g,
            '_',
          )}`,
        )
        await axiosAWS
          .post('/upload', formDataMobile)
          .then(async response => {
            imageUrl.value.imagem_mobile = response.data.image_url
            imageUrl.value.imagem_mobile_key = response.data.key
          })
      }
    }

    const handleSubmit = async () => {
      if (itemData.value.imagem === null) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Imagem é obrigatória',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
        return
      }
      if (itemData.value.imagem && itemData.value.imagem_mobile) {
        await uploadImagem()
      }

      if (itemData.value.id !== null) {
          store.dispatch('Banners/update', {
            ...itemData.value,
            imagem: imageUrl.value.imagem,
            imagem_key: imageUrl.value.imagem_key,
            imagem_mobile: imageUrl.value.imagem_mobile,
            imagem_mobile_key: imageUrl.value.imagem_mobile_key,
          })
          .then(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Sucesso',
                text: 'Banner atualizado com sucesso',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            resetClienteData()
            router.push({ name: 'app-admin-banners' })
          })

        return
      }
        store.dispatch('Banners/create', {
          ...itemData.value,
          imagem: imageUrl.value.imagem,
          imagem_key: imageUrl.value.imagem_key,
          imagem_mobile: imageUrl.value.imagem_mobile,
          imagem_mobile_key: imageUrl.value.imagem_mobile_key,
        })
        .then(resp => {
          itemData.value.id = resp.data.id
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Banner criado com sucesso',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          resetClienteData()
          router.push({ name: 'app-admin-banners' })
        })
    }

    onMounted(() => {
      if (typeof router.currentRoute.params.id !== 'undefined') {
        store.dispatch('Banners/findById', { id: router.currentRoute.params.id })
          .then(response => {
            const item = response.data
            itemData.value = {
              id: item.id,
              uuid: item.uuid,
              nome: item.nome,
              imagem: item.imagem,
              imagem_key: item.imagem_key,
              imagem_mobile: item.imagem_mobile,
              imagem_mobile_key: item.imagem_mobile_key,
              ativo: item.ativo,
              nome_tag: item.nome_tag,
              link: item.link,
            }
            imageUrl.value = {
              imagem: item.imagem,
              imagem_key: item.imagem_key,
              imagem_mobile: item.imagem_mobile,
              imagem_mobile_key: item.imagem_mobile_key,
            }
          })
          .catch(e => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                text: e,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            resetClienteData()
          })
      }
      if (typeof router.currentRoute.params.id === 'undefined') {
        store.dispatch('appAdmProdutos/clearItemData')
      }
    })

    return {
      itemData,
      handleSubmit,
      resetClienteData,
      removeImagem,
    }
  },
}
</script>

<style>

</style>
